import { useEffect, useState } from "react";
import { api, fmtMoney, fmtDate } from "@/lib/api";
import { PageHeader, PageBody } from "@/components/common/PageHeader";
import EmptyState from "@/components/common/EmptyState";
import { ArrowUpFromLine } from "lucide-react";

export default function PaymentsMade() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => { api.get("/payments-made").then(({ data }) => { setItems(data); setLoading(false); }); }, []);
    return (
        <>
            <PageHeader kicker="PURCHASES" title="Payments Made" subtitle="Outflows to vendors with allocations and bank impact." />
            <PageBody>
                <div className="bg-card border border-border rounded-md overflow-hidden">
                    {loading ? <div className="p-8 text-muted-foreground text-center">Loading…</div> :
                        items.length === 0 ? <EmptyState icon={ArrowUpFromLine} title="No payments made" description="Vendor payments will appear here." /> :
                            <table className="fin-table">
                                <thead><tr><th>Number</th><th>Vendor</th><th>Date</th><th>Method</th><th className="num">Amount</th></tr></thead>
                                <tbody>
                                    {items.map((p) => (
                                        <tr key={p.id}>
                                            <td className="font-mono text-[12.5px]">{p.number}</td>
                                            <td>{p.party_name}</td>
                                            <td className="text-[12px] text-muted-foreground">{fmtDate(p.date)}</td>
                                            <td className="text-[12px]">{p.method}</td>
                                            <td className="num">{fmtMoney(p.amount, p.currency)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>}
                </div>
            </PageBody>
        </>
    );
}
